import { SalesItemService, SalesPackageService } from "@common/services";
import { flow } from "mobx";
import { NotificationStoreInstance } from "@common/stores";
import { DateTime } from "luxon";
import { SalesStore } from "./SalesStore";
import { PriceCheckSalesBuilderSearchStore } from "@hospital/stores/PriceCheckSalesBuilderSearchStore";

export class PriceCheckStore extends SalesStore {
    constructor() {
        super();
        this.visitBuilderSearch = new PriceCheckSalesBuilderSearchStore(this);
    }

    public loadPriceChecker = flow(function* (this: PriceCheckStore, clinicId: number) {
        yield Promise.all([
            this.getSalesItemsForPriceCheck.call(this, clinicId),
            this.getSalesPackagesForPriceCheck.call(this, clinicId)
        ]);
    });

    public getSalesItemsForPriceCheck = flow(function* (this: PriceCheckStore, clinicId: number) {
        const now = DateTime.now();
        const unfilteredSalesItems = clinicId == undefined
            ? []
            : yield SalesItemService
                .fetchSalesItems(clinicId, now)
                .then(items => items.salesItems)
                .catch(NotificationStoreInstance.onError("Failed to fetch visit sales items", this.salesItems));
        if (_.isArray(unfilteredSalesItems)) {
            const userAddedSalesItems = this.filterToSalesItemsThatCanBeAddedByUsers(unfilteredSalesItems)
            this.salesItems = this.mapSalesItemsForVisitBuilder(userAddedSalesItems)
        }
    });

    public getSalesPackagesForPriceCheck = flow(function* (this: PriceCheckStore, clinicId: number) {
        const now = DateTime.now();
        this.salesPackages = clinicId == undefined
            ? undefined
            : yield SalesPackageService
                .getClinicSalesPackages(clinicId, now)
                .then(items => items)
                .catch(NotificationStoreInstance.onError("Failed to fetch visit sales items", this.salesPackages));
    });
}
